import react from "react";

import scimparello1 from "../images/commercials/Scimparello/01SCIMPARELLOjpg Large.jpeg";
import scimparello2 from "../images/commercials/Scimparello/02SCIMPARELLO Large.jpeg";
import scimparello3 from "../images/commercials/Scimparello/03SCIMPARELLO Large.jpeg";
import scimparello4 from "../images/commercials/Scimparello/04SCIMPARELLO Large.jpeg";
import scimparello5 from "../images/commercials/Scimparello/05SCIMPARELLO Large.jpeg";
import scimparello6 from "../images/commercials/Scimparello/06SCIMPARELLO Large.jpeg";
import scimparello7 from "../images/commercials/Scimparello/07SCIMPARELLO Large.jpeg";
import scimparello8 from "../images/commercials/Scimparello/08SCIMPARELLO Large.jpeg";
import scimparello9 from "../images/commercials/Scimparello/09SCIMPARELLO Large.jpeg";
import scimparello10 from "../images/commercials/Scimparello/10SCIMPARELLO Large.jpeg";
import scimparello11 from "../images/commercials/Scimparello/11SCIMPARELLO Large.jpeg";
import scimparello12 from "../images/commercials/Scimparello/12SCIMPARELLO Large.jpeg";
import scimparello13 from "../images/commercials/Scimparello/13SCIMPARELLO Large.jpeg";
import scimparello14 from "../images/commercials/Scimparello/14SCIMPARELLO Large.jpeg";
import scimparello15 from "../images/commercials/Scimparello/15SCIMPARELLO Large.jpeg";
import scimparello16 from "../images/commercials/Scimparello/16SCIMPARELLO Large.jpeg";
import scimparello17 from "../images/commercials/Scimparello/17SCIMPARELLO Large.jpeg";
import scimparello18 from "../images/commercials/Scimparello/18SCIMPARELLO Large.jpeg";
import scimparello19 from "../images/commercials/Scimparello/19SCIMPARELLO Large.jpeg";
import scimparello20 from "../images/commercials/Scimparello/20SCIMPARELLO Large.jpeg";

const Scimparello = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={scimparello1} alt="Scimparello - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello2} alt="Scimparello - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello3} alt="Scimparello - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello4} alt="Scimparello - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello6} alt="Scimparello - Image 6"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello5} alt="Scimparello - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello7} alt="Scimparello - Image 7"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello8} alt="Scimparello - Image 8"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello9} alt="Scimparello - Image 9 "/>
                </div>
                <div className="single portrait">
                    <img src={scimparello10} alt="Scimparello - Image 10"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello11} alt="Scimparello - Image 11"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello12} alt="Scimparello - Image 12"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello13} alt="Scimparello - Image 13"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello14} alt="Scimparello - Image 14"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello15} alt="Scimparello - Image 15"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello16} alt="Scimparello - Image 16"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello18} alt="Scimparello - Image 18"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello17} alt="Scimparello - Image 17"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello19} alt="Scimparello - Image 19"/>
                </div>
                <div className="single portrait">
                    <img src={scimparello20} alt="Scimparello - Image 20"/>
                </div>
            </div>
        </div>
    );
}

export default Scimparello;